import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export class GlobalConstants {
    public static currencyCodePrefix = 'currency-codes.';
    public static ecsQrCodePrefix = 'eCredits:';
    public static storeAddressErrors = {
        geolocationFailed: _('store.store-address.geolocation-failed'),
        geolocationNotSupported: _('store.store-address.geolocation-not-supported'),
    };
}

